import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import InsightList from 'src/components/ProductDetails/types/InsightList';
import InsightSegment from 'src/components/ProductDetails/types/InsightSegment';
import { getInsights } from 'src/components/ProductDetails/api/insights.api';

export type InsightListState = FetchState<InsightSegment[]>;

type UseInsightListFetchProps = {
  matchType: string;
  ownerId: string;
  regionId: string;
  priceType: string;
  sourceOwnerId: string;
  sourceProductId: string;
};

const initialState: InsightListState = {
  loading: false,
  error: false,
  data: null,
};

const useInsightListFetch = ({
  matchType,
  ownerId,
  regionId,
  priceType,
  sourceOwnerId,
  sourceProductId,
}: UseInsightListFetchProps): [InsightListState] => {
  const params: InsightList.Request = {
    ownerId,
    matchType,
    regionId,
    priceType,
    sourceOwnerId,
    sourceProductId,
  };
  const [{ loading, data, error }] = useFetchReducer(
    () => getInsights(params),
    [matchType, regionId, priceType, sourceOwnerId, sourceProductId, ownerId]
  );
  const state: InsightListState = { ...initialState, loading, error };

  if (!data) {
    return [state];
  }

  const sortedData = [...data].sort((ownerA, ownerB) => {
    if (ownerA.ownerId === 0) {
      return -1;
    }
    return ownerA.ownerName && ownerB.ownerName ? ownerA.ownerName.localeCompare(ownerB.ownerName) : 1;
  });

  const sortedDataWithMessages = sortedData.map((insight) => ({
    ...insight,
    insightMessages: [...insight.insightMessages].sort((insightMsgA, insightMsgB) =>
      insightMsgA.localeCompare(insightMsgB)
    ),
  }));

  return [
    {
      ...state,
      data: sortedDataWithMessages,
    },
  ];
};

export default useInsightListFetch;
